<template>
  <div class="shop-intro">
    <img v-if="cover" :src="cover" />
    <div class="shop-intro__image-fade"></div>

    <div class="shop-intro__content">
      <div class="shop-intro__content-default">
        <h2 class="shop-intro__title">{{ $tc('shop', 1) }}</h2>
        <div class="shop-intro__reference">{{ $path('reference.name', value) }}</div>
        <div class="shop-intro__description" v-html="description"></div>

        <ButtonComponent
          :label="$t('next')"
          :icon="['fal', 'angle-right']"
          theme="primary"
          class="shop-intro__next"
          :href="`${$path('shop.url', value)}`"
          target="_blank"
          :track="{ event: 'navigate:shop', url: $path('shop.url', value) }"
          tag="a"
        />
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'

export default {
  props: {
    value: Object,
  },
  computed: {
    description() {
      return this.$path('value.shop.description') || this.$t('shopWelcomeMessage')
    },
    cover() {
      return this.$path('value.shop.cover.url') || this.$path('value.media.cover.0.url')
    },
  },
  components: {
    ButtonComponent,
  },
}
</script>

<style lang="scss">
.shop-intro {
  a {
    .elder-button__label {
      text-shadow: none !important;
    }
  }
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2rem;
  height: 100%;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.3;
    pointer-events: none;
  }

  &__image-fade {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at center, transparent, white 90%);
  }

  &__reference {
    opacity: 0.5;
    margin-bottom: 1.5rem;
  }

  &__title {
    margin: 0;
  }

  &__description {
    max-width: 40ch;
  }

  &__content {
    margin-bottom: 4rem;
    white-space: pre-line;
    font-size: 1.2em;
    z-index: 1;

    display: flex;
    flex-wrap: wrap;
    gap: 4rem;

    --shadow-color: white;
    --shadow-blur: 20px;
    --shadow-offset: 0.08em;
    text-shadow: var(--shadow-offset) 0 var(--shadow-blur) var(--shadow-color),
      0 var(--shadow-offset) var(--shadow-blur) var(--shadow-color),
      calc(var(--shadow-offset) * -1) 0 var(--shadow-blur) var(--shadow-color),
      0 calc(var(--shadow-offset) * -1) var(--shadow-blur) var(--shadow-color);
  }

  &__next {
    margin-top: 2rem;
  }
}
</style>
